<template>
  <div>
    <!-- 视频播放 -->
    <van-overlay :show="showVideo" @click="hideVideoMsg" class="van-overlayes">
        <div class="dplayer-containers" @click.stop>
            <div id="dplayer" class="video-container"></div>
        </div>
    </van-overlay>
  </div>
</template>

<script>
import DPlayer from 'dplayer'
export default {
    props: {
        
    },
    data() {
        return {
           showVideo:false
        }
    },
    methods: {
        dplayerOption (videoUrl, pic) {
            this.showVideo = true
            const dp = new DPlayer({
                container: document.getElementById('dplayer'),
                // screenshot: false,
                autoplay: true,
                video: {
                    url: videoUrl || '',
                    pic: pic || '',
                    thumbnails: 'thumbnails.jpg'
                }
            })
            this.dp = dp
        },
        // 隐藏video蒙版
        hideVideoMsg () {
            this.showVideo = false
            this.dp.pause()
            this.dp.fullScreen.cancel('web') // 退出全屏
        }
    }
}
</script>

<style>

</style>